module.exports = __webpack_public_path__ + "static/icon-8d912e14b61e3134f8eba99d01d7664f.png";